module.exports = {"id":"208250","name":"Anastasios Bakasetas","rating":"72","photo":"./data/images/photos/4/208250.png","club":{"name":"AEK Athènes","logo":"./data/images/clubs/AEKAthenes.png"},"positions":["MOC","MD","BU"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AnastasiosBakasetas0.json
// module id = 320
// module chunks = 0